module.exports = __webpack_public_path__ + "static/media/Unlock Blue.3187f18f.svg";